import React from 'react';

import { DetailInstrument } from 'types/drupal/InstrumentNode';

interface Props {
    item: DetailInstrument;
}

const ItemLabel: React.StatelessComponent<Props> = ({ item }) => (
    <div className="item-label">
        <h1>
            <span>{item.field_manufacturer && item.field_manufacturer.manufacturer.name}</span>
            <span> {item.field_instr_model && item.field_instr_model.value}</span>
            <span> {item.field_instr_year && item.field_instr_year.value}</span>
        </h1>
        <div className="serial">Product Code: {item.field_gruhn_category_id.value}</div>

    </div>
);

export default ItemLabel;



// WEBPACK FOOTER //
// ./src/components/pages/inventory/detail/ItemLabel.tsx